import api from "./api";
import { stringifyValues } from "../utils/tableFunctions";
import { Log } from "./services";

export function getSDMerchant(setList, setLoaded, download = "false", filter) {
  const url = "/report/admin/deposit/filter/";
  filter = stringifyValues(filter);
  api
    .post(url, {
      ...filter,
      download: download,
    })
    .then((response) => {
      setList(response.data);
      setLoaded && setLoaded(true);
    });
}

export function getSDFilterParam(setParams) {
  const url = "/report/admin/deposit/filter_conditions/";
  api.get(url).then((response) => {
    setParams(response.data);
  });
}

export function getSDDetails(id, setList, setLoaded) {
  const url = "/report/admin/deposit/report_details/" + id + "/";
  api.get(url).then((response) => {
    setList(response.data);
    setLoaded(true);
  });
}

export function getSDMerchantDetails(
  merchant_id,
  currency,
  setList,
  setLoaded
) {
  const url = "/report/admin/deposit/merchant_details/";
  api
    .post(url, {
      merchant_id,
      currency,
    })
    .then((response) => {
      setList(response.data);
      setLoaded(true);
    });
}

export async function getSDCSV(filter) {
  const url = "/report/admin/deposit/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, { download: "true", ...filter });
  return data.data;
}

export async function getSDDetailsDownload(merchant_id, currency) {
  const url = `/report/admin/deposit/merchant_details/`;
  const data = await api.post(url, {
    merchant_id,
    currency,
    download: "true",
  });
  return data.data;
}
